
import React, { Component } from "react";

class Resume extends Component {
  render() {
    if (!this.props.data) return null;

    const work = this.props.data.work;
    const skillGroups = [
      ["Languages", ["C#", "TypeScript", "JavaScript", "CSS", "SQL"]],
      ["Frameworks", ["ReactJS", "AngularJS", "ASP.NET Core", "ASP.NET MVC"]],
      ["Cloud & tooling", ["Azure", "Google Cloud"]],
      ["Practices", ["Agile", "Testing & QA", "Systems Architecture"]],
    ];

    return (
      <section id="resume" className="resume-section">
        <div className="section-title"><h2>Experience</h2><span>2019 - now</span></div>
        <div className="roles-list">
          {work.map((role) => (
            <article className="role" key={role.company}>
              <p className="role-years">{role.years}</p>
              <div>
                <h3>{role.title}</h3>
                <strong>{role.company}</strong>
                {/* <p>{role.description}</p> */}
              </div>
            </article>
          ))}
        </div>
        <div className="skill-grid">
          {skillGroups.map(([title, skills]) => <div className="skill-group" key={title}><h3>{title}</h3><div>{skills.map((skill) => <span key={skill}>{skill}</span>)}</div></div>)}
        </div>
        {/* <div id="projects" className="section-title"><h2>Featured projects</h2><span>Selected work</span></div>
        <div className="project-grid">
          <article><small>Awards platform</small><h3>New York Festivals</h3><p>Full platform powering awards, judging and content for a global organization.</p></article>
          <article><small>Healthcare</small><h3>Clinical Systems</h3><p>End-to-end applications supporting clinical and patient-facing workflows.</p></article>
          <article><small>Frontend</small><h3>Design System</h3><p>A reusable component library unifying brand and UX across multiple products.</p></article>
          <article><small>Cloud</small><h3>Platform Migration</h3><p>Modernized legacy applications onto ASP.NET Core with Azure and Google Cloud.</p></article>
        </div> */}
        <div id="education" className="section-title"><h2>Education</h2></div>
        <div className="education-strip">
          <div className="education-item"><h3>{this.props.data.education[0].degree}</h3><p>{this.props.data.education[0].school} - {this.props.data.education[0].graduated}</p></div>
        </div>
      </section>
    );
  }
}

export default Resume;
